export default {
  'common.welcome': '欢迎',
  'common.logout': '退出登录',
  'common.settings': '设置',
  'common.language': '语言',
  'common.loading': '加载中...',
  'common.error': '错误',
  'common.retry': '重试',
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.save': '保存',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.search': '搜索',
  'common.noData': '暂无数据',
  'common.goHome': '返回首页',
  'common.goBack': '返回',
  'common.success': '成功',
  'common.warning': '警告',
  'common.info': '提示',
  'common.operationSuccess': '操作成功完成',
  'common.operationError': '发生错误',
};
